<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !outsourceCompanyVisible && !outsourceFeeFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.customerCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务品牌</span>
            <el-input
              v-model="listQuery.brand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
              v-model="listQuery.model"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">序列号</span>
            <el-input
              v-model="listQuery.serial"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">订单号</span>
            <el-input
              v-model="listQuery.customerOrderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <template v-if="salesManOption.length">
                <el-option
                  v-for="item in salesManOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">工程师</span>
            <el-select :filterable="true" v-model="listQuery.engineerId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleEngineerFocus" @change="handleFilter">
              <template v-if="engineerOption.length">
                <el-option
                  v-for="item in engineerOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">紧急程度</span>
            <el-select :filterable="true" v-model="listQuery.urgentId" class="filter-item" placeholder="" clearable @change="handleFilter" :size="t('table.btnSize')">
              <template v-if="urgentOption.length">
                <el-option
                  v-for="item in urgentOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <!-- <div class="filter-box">
            <span class="label">业务状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div> -->
          <!-- 外包商==> 供应商 -->
          <div class="filter-box">
            <span class="label">外包商</span>
            <el-input
              v-model="listQuery.outsourceCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              @keyup.enter="handleFilter"
              clearable
            />
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <el-radio-group v-model="listQuery.outsourceFeeStatus" @change="handleFilter">
              <el-radio label="1" >未申请</el-radio>
              <el-radio label="4" >可申请</el-radio>
              <el-radio label="2" >未付款</el-radio>
              <el-radio label="3" >未开票</el-radio>
              <el-radio label="9" >全部</el-radio>
            </el-radio-group>
          </div>

        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_COMPANY_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('outSourceCompany')"
          >
            新建外包商
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">此列表只显示需要申请外包费和维修完成的业务，外包费全部审批完成之后才显示维修完成</span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :isShowPagination="false"
              :handleDefaultWidth="160"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              style="height:100% ;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <ContactList v-if="activeTab === 1" ref="ContactList" :id="activeId"/>
              <OutsourceFee v-if="activeTab === 2" ref="OutsourceFee" :id="activeId" :businessDetail="activeRow"/>
              <MarketFee v-if="activeTab === 4" ref="MarketFee" :id="activeId" :marketFeeCanCommand="false"/>
              <LogisticTable :sendFlag="0" TableName="TABLE_DELIVERY_INFO" permissionName="LOGISTIC_INFO" v-if="activeTab === 5" ref="LogisticTable" :sourceId="activeId" :sourceType="2" :canCommand="false"/>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="business"/>
        </div>
      </div>
    </div>
     <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'business'"
      :commandState="commandState"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <FormComponent
      v-if="outsourceCompanyVisible"
      :id="0"
      :initFormData="initFormDataOutsourceCompany"
      :fromFieldData="fromFieldDataOutsourceCompany"
      :dialogFormVisible="outsourceCompanyVisible"
      :handleResolveTempData="handleResolveTempDataOutsourceCompany"
      :api="'outsourceCompany'"
      @update:visibel="() => outsourceCompanyVisible = false"
      @submit="handleOutsourceCompanySubmit"
    />
    <QutsourceFeeForm
      v-if="outsourceFeeFormVisible"
      :id="0"
      :businessDetail="activeRow"
      :dialogFormVisible="outsourceFeeFormVisible"
      :api="'outsourceFee'"
      @update:visibel="outsourceFeeFormVisible = false"
      @submit="getList"
    />    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible && !outsourceCompanyVisible && !outsourceFeeFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, nextTick, computed, watch } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'
import { updateRepair } from '@/apis/Repair'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'

import ContactList from '@/views/business/businessList/contact/Index.vue'
import OutsourceFee from './outsourceFee/Index.vue'
// import OutsourceFeeTicket from './outsourceFeeTicket/Index.vue'

import MarketFee from '@/views/business/businessList/businessMarketFee/Index.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import LogisticTable from '@/views/logistics/components/Table.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/businessList/FieldFrom'
import { TableField } from '@/views/business/businessList/FieldTable'
import { FromFieldData as FromFieldDataOutsourceCompany } from '@/views/business/outsourceCompany/FieldFrom'

import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import mixin from '@/mixins/index'
import QutsourceFeeForm from './outsourceFee/Form.vue'
import CommandRender from '@/components/common/CommandRender.vue'

import { useI18n } from 'vue-i18n'
import { verifyBusinessAction } from '@/apis/Business'
export default defineComponent({
  name: 'Outsourcebusiness',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ContactList,
    TraceInfo,
    MarketFee,
    OutsourceFee,
    LogisticTable,
    QutsourceFeeForm,
    CommandRender
    // OutsourceFeeTicket
  },
  setup() {
    const { t } = useI18n()
    const ContactList = ref(null)
    const OutsourceFee = ref(null)
    const MarketFee = ref(null)
    const TraceInfo = ref(null)
    const dataForm = ref(ElForm)
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_OUTSOURCE_BUSINESS,
      permissionName: permissionName.OUTSOURCE_BUSINESS,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,
      initFormDataOutsourceCompany: cloneDeep(FromFieldDataOutsourceCompany),
      fromFieldDataOutsourceCompany: cloneDeep(FromFieldDataOutsourceCompany),

      activeId: 0,
      activeRow: {},
      activeRate: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        customerCompanyName: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        outsourceFeeStatus: '1',
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      outsourceCompanyVisible: false,
      tabList: [
        { name: '外包费', id: 2 }
        // { name: '联系人', id: 1 },
        // { name: '市场费', id: 4 },
        // { name: '物流信息', id: 5 },
        // { name: '跟踪信息', id: 3 }
      ],
      activeTab: 2,

      salesManId: '',
      newHpx: 0,
      statusOption: [],
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      salesManOption: [],
      selectionArray: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      achieveType: '',
      outsourceFeeFormVisible: false,
      ruleForm: {
        invoiceNumber: '',
        no: '',
        code: '',
        checkCode: '',
        amount: 0,
        date: '',
        mark: ''
      },
      rules: {
        invoiceNumber: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        no: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        code: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        amount: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        checkCode: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        date: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      async handleCommand(command: string, val?: any) {
        if (command !== 'column') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
        }
        dataMap.commandState = command
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'outSourceCompany':
            dataMap.outsourceCompanyVisible = true
            break
          case 'fee':
            (MarketFee.value as any).handleCommand('add')
            break
          case 'outsourceFee':
            // console.log(OutsourceFee.value, 'OutsourceFee.value'); (OutsourceFee.value as any).handleCommand('add')
            verifyBusinessAction(val.id, 'addOutsourceFee').then(() => {
              dataMap.outsourceFeeFormVisible = true
            })
            break
          case 'repaired':
            dataMap.handleRepaired(val)
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
        dataMap.activeRow = row
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (ContactList.value && ContactList.value) {
            ;(ContactList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 3) {
          if (TraceInfo.value && TraceInfo.value) {
            ;(TraceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList('business', { ...dataMap.listQuery, type: 4, pageType: 'OUTSOURCE', receivedStatus: dataMap.listQuery.outsourceFeeStatus === '3' ? undefined : dataMap.listQuery.outsourceFeeStatus }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
          dataMap.activeRow = dataMap.list.length ? dataMap.list[0] : {}
        }).catch((error: any) => {
          console.log(error, 2222)
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          customerCompanyName: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          outsourceFeeStatus: '1',
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        getDetailById('business', row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleRepaired(row: any) {
        ElMessageBox.confirm(
          '确定选中业务已经完成？',
          '确定',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            updateRepair(row.id, { complete: true }).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleBarCodeChange() {
        // 01,10,031002000411,51548062,924.53,20211223,62768369661843286906,92A4
        const value = dataMap.ruleForm.invoiceNumber
        const code = value.split(',') || []
        dataMap.ruleForm.no = code[2]
        dataMap.ruleForm.code = code[3]
        dataMap.ruleForm.checkCode = code[6]
        const amount = Number(code[4])
        dataMap.ruleForm.amount = Math.floor(amount * ((Number(dataMap.activeRate) + 100) / 100))
        dataMap.ruleForm.date = `${code[5].slice(0, 4)}-${code[5].slice(4, 6)}-${code[5].slice(6, 8)}`
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleOutsourceCompanySubmit() {
        dataMap.getList()
      },
      handleResolveTempDataOutsourceCompany(tempModel: any) {
        const { address } = tempModel
        let contacts = tempModel.contacts
        if (contacts) {
          contacts.map((k: any) => {
            k.address = address ? address.join('-') : ''
            return {
              ...k
            }
          })
        } else {
          contacts = []
        }
        tempModel.address = address ? address.join('-') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
        getUrlList('urgency/dropdown').then((res: any) => {
          dataMap.urgentOption = res || []
        })
        getUrlList('dropdown/BusinessType').then((res: any) => {
          dataMap.businessTypeOption = res || []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      }
    })
    const btnList = computed(() => {
      const status = dataMap.listQuery.outsourceFeeStatus
      const permissionName = dataMap.permissionName

      if (status === '1' || status === '4') {
        return [{
          pkey: 'OUTSOURCE_BUSINESS_FEE_ADD',
          name: '申请外包费',
          command: 'outsourceFee',
          visible: (row: any) => row.repairStatus !== '维修完成'
        }]
      }

      if (status === '9') {
        return [{
          pkey: `${permissionName}_REPAIRED`,
          name: '维修完成',
          command: 'repaired',
          visible: (row: any) => row.repairStatus !== '维修完成'
        }]
      }

      return []
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./business/outsourceBusiness',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })

    onMounted(async() => {
      mixinData.initHeight()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap), dataForm, ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableListRef, OutsourceFee, btnList }
  }
})
</script>
<style  lang="scss">
.grid-layout-container {
.vue-grid-item {
  background:#666 ;
}
}
</style>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
.warming-fp{
  border-radius: 4px;
  border: 1px solid $red;
  color:$red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
